import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';

const STATUS_LABELS = {
    pending: { label:'รอดำเนินการ', color:'#ffc107', icon:'fas fa-clock' },
    contacted: { label:'ติดต่อแล้ว', color:'#17a2b8', icon:'fas fa-phone' },
    quoted: { label:'เสนอราคาแล้ว', color:'#6610f2', icon:'fas fa-file-invoice-dollar' },
    confirmed: { label:'ยืนยันเดินทาง', color:'#28a745', icon:'fas fa-check-circle' },
    closed: { label:'ปิดเคส', color:'#6c757d', icon:'fas fa-times-circle' }
};

export class GroupRequestList extends Component {
    constructor(props) {
        super(props);
        this.state = { list: [], loading: true, statusFilter: '', search: '' };
    }

    componentDidMount() { this.load(); }

    load() {
        this.setState({ loading: true });
        var q = this.state.statusFilter ? '?status=' + this.state.statusFilter : '';
        fetch('api/grouprequest' + q)
            .then(r => r.ok ? r.json() : [])
            .then(list => this.setState({ list, loading: false }))
            .catch(() => this.setState({ loading: false }));
    }

    getFiltered() {
        var { list, search } = this.state;
        if (!search.trim()) return list;
        var s = search.trim().toLowerCase();
        return list.filter(x => (x.name||'').toLowerCase().includes(s) || (x.phone||'').toLowerCase().includes(s) || (x.destination||'').toLowerCase().includes(s));
    }

    render() {
        var { list, loading, statusFilter, search } = this.state;
        var filtered = this.getFiltered();

        return (
            <div style={{ padding: 20 }}>
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <p style={{ margin: 0, fontSize: 13, color: '#888' }}>ทั้งหมด {list.length} รายการ</p>
                </div>

                <div style={{ background:'#fff', borderRadius:10, padding:16, boxShadow:'0 2px 12px rgba(0,0,0,0.06)', marginBottom:20 }}>
                    <div className="d-flex flex-wrap" style={{ gap:8 }}>
                        <button className={'btn btn-sm ' + (statusFilter === '' ? 'btn-dark' : 'btn-outline-secondary')} onClick={()=>this.setState({statusFilter:''}, ()=>this.load())}>ทั้งหมด</button>
                        {Object.keys(STATUS_LABELS).map(k => {
                            var s = STATUS_LABELS[k];
                            return <button key={k} className={'btn btn-sm ' + (statusFilter === k ? 'btn-dark' : 'btn-outline-secondary')}
                                onClick={()=>this.setState({statusFilter:k}, ()=>this.load())}>
                                <i className={s.icon} style={{ color:s.color }}></i> {s.label}
                            </button>;
                        })}
                        <div className="input-group" style={{ maxWidth:320, marginLeft:'auto' }}>
                            <span className="input-group-text" style={{ background:'#fff' }}><i className="fas fa-search" style={{ color:'#aaa' }}></i></span>
                            <input className="form-control" placeholder="ค้นหา ชื่อ/เบอร์/จุดหมาย" value={search} onChange={e=>this.setState({search:e.target.value})} style={{ borderLeft:'none' }} />
                        </div>
                    </div>
                </div>

                {loading ? (
                    <div className="text-center py-5"><div className="spinner-border text-danger"></div></div>
                ) : filtered.length === 0 ? (
                    <div className="text-center py-5" style={{ color:'#bbb' }}>
                        <i className="fas fa-inbox" style={{ fontSize:48, display:'block', marginBottom:12 }}></i>
                        ไม่พบรายการ
                    </div>
                ) : (
                    <div className="table-responsive" style={{ background:'#fff', borderRadius:10, boxShadow:'0 2px 12px rgba(0,0,0,0.06)' }}>
                        <table className="table table-hover mb-0" style={{ fontSize:14 }}>
                            <thead style={{ background:'#f8f9fa' }}>
                                <tr>
                                    <th style={{ width:60 }}>#</th>
                                    <th>ผู้ติดต่อ</th>
                                    <th>ติดต่อ</th>
                                    <th style={{ width:90, textAlign:'center' }}>จำนวน</th>
                                    <th>จุดหมาย / โปรแกรม</th>
                                    <th style={{ width:110 }}>วันเดินทาง</th>
                                    <th style={{ width:140 }}>สถานะ</th>
                                    <th style={{ width:130 }}>วันที่ส่ง</th>
                                    <th style={{ width:90, textAlign:'center' }}>กิจกรรม</th>
                                    <th style={{ width:80 }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {filtered.map(r => {
                                    var s = STATUS_LABELS[r.status] || STATUS_LABELS.pending;
                                    var hasActivity = r.lastActivityNote || r.lastActivityAt;
                                    return (
                                        <React.Fragment key={r.id}>
                                            <tr>
                                                <td style={{ color:'#aaa', borderBottom: hasActivity ? 'none' : undefined }}>{r.id}</td>
                                                <td style={{ fontWeight:600, borderBottom: hasActivity ? 'none' : undefined }}>{r.name}</td>
                                                <td style={{ fontSize:12, borderBottom: hasActivity ? 'none' : undefined }}>
                                                    <div><i className="fas fa-phone" style={{ color:'#888' }}></i> {r.phone}</div>
                                                    {r.email && <div style={{ color:'#888' }}><i className="fas fa-envelope"></i> {r.email}</div>}
                                                </td>
                                                <td style={{ textAlign:'center', borderBottom: hasActivity ? 'none' : undefined }}>{r.pax > 0 ? r.pax + ' ท่าน' : '-'}</td>
                                                <td style={{ borderBottom: hasActivity ? 'none' : undefined }}>
                                                    {r.programCode && <div style={{ fontSize:12, color:'#dc3545' }}><i className="fas fa-tag"></i> {r.programCode} {r.programName}</div>}
                                                    {r.destination && <div>{r.destination}</div>}
                                                </td>
                                                <td style={{ fontSize:12, borderBottom: hasActivity ? 'none' : undefined }}>{r.travelDate ? dayjs(r.travelDate).format('D MMM YY') : '-'}</td>
                                                <td style={{ borderBottom: hasActivity ? 'none' : undefined }}>
                                                    <span style={{ background:s.color, color:'#fff', padding:'3px 10px', borderRadius:20, fontSize:11, fontWeight:600 }}>
                                                        <i className={s.icon}></i> {s.label}
                                                    </span>
                                                </td>
                                                <td style={{ fontSize:12, color:'#888', borderBottom: hasActivity ? 'none' : undefined }}>{r.createdAt ? dayjs(r.createdAt).format('D MMM YY HH:mm') : '-'}</td>
                                                <td style={{ textAlign:'center', borderBottom: hasActivity ? 'none' : undefined }}>
                                                    <span style={{ display:'inline-block', minWidth:32, background: (r.activityCount > 0 ? '#dc3545' : '#adb5bd'), color:'#fff', padding:'5px 12px', borderRadius:14, fontSize:14, fontWeight:700 }}>
                                                        {r.activityCount || 0}
                                                    </span>
                                                </td>
                                                <td style={{ borderBottom: hasActivity ? 'none' : undefined }}>
                                                    <Link to={'/console/grouprequest/' + r.id} className="btn btn-outline-primary btn-sm"><i className="fas fa-eye"></i> ดู</Link>
                                                </td>
                                            </tr>
                                            {hasActivity && (
                                                <tr>
                                                    <td colSpan="10" style={{ padding:'0 16px 12px 16px', background:'#fafbfc', borderTop:'none' }}>
                                                        <div style={{ fontSize:12, borderLeft:'3px solid #dc3545', paddingLeft:10, marginLeft:40 }}>
                                                            <div style={{ color:'#888', marginBottom:2 }}>
                                                                <i className="fas fa-history"></i> กิจกรรมล่าสุด
                                                                {r.lastActivityBy && <span style={{ marginLeft:8 }}>โดย <strong>{r.lastActivityBy}</strong></span>}
                                                                {r.lastActivityAt && <span style={{ marginLeft:8 }}>· {dayjs(r.lastActivityAt).format('D MMM YY HH:mm')}</span>}
                                                            </div>
                                                            {r.lastActivityNote && <div style={{ whiteSpace:'pre-wrap', color:'#333' }}>{r.lastActivityNote}</div>}
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        );
    }
}
